module.exports = __webpack_public_path__ + "static/media/日历9@2x.47fb22ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历9@2x.png
// module id = 1382
// module chunks = 0